module.exports = __webpack_public_path__ + "static/TrueFood_pin-6f76e73066096982f4455fa080385ea2.png";